import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { Button } from "../ui/button";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";

export const CartDrawer = () => {
  const { items, drawerOpen, setDrawerOpen, updateQty, removeItem, total, setCheckoutOpen } = useCart();

  return (
    <Sheet open={drawerOpen} onOpenChange={setDrawerOpen}>
      <SheetContent side="right" className="w-full sm:max-w-md bg-[#F9F6F0] border-l border-[#E8E3DA] flex flex-col p-0" data-testid="cart-drawer">
        <SheetHeader className="px-6 py-5 border-b border-[#E8E3DA]">
          <SheetTitle className="font-serif text-2xl text-[#1E1A17] text-left">Your Basket</SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-center px-8 gap-4">
            <div className="h-16 w-16 rounded-full bg-[#F2EBE1] flex items-center justify-center">
              <ShoppingBag className="h-7 w-7 text-[#B4A79A]" />
            </div>
            <p className="text-[#3D352F]">Your basket is empty.</p>
            <button onClick={() => setDrawerOpen(false)} className="text-[#B83A14] text-sm underline underline-offset-4" data-testid="cart-continue-shopping">
              Browse the pickles
            </button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
              {items.map((i) => (
                <div key={i.id} className="flex gap-4" data-testid={`cart-item-${i.id}`}>
                  <img src={i.image} alt={i.name} className="h-20 w-16 object-cover rounded-md bg-[#F2EBE1]" />
                  <div className="flex-1">
                    <div className="flex justify-between">
                      <p className="font-serif text-lg text-[#1E1A17]">{i.name}</p>
                      <button aria-label="Remove item" onClick={() => removeItem(i.id)} data-testid={`cart-remove-${i.id}`}>
                        <Trash2 className="h-4 w-4 text-[#B4A79A] hover:text-[#B83A14] transition-colors" />
                      </button>
                    </div>
                    <p className="text-[#B83A14] text-sm mt-0.5">₹{i.price}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <button onClick={() => updateQty(i.id, -1)} data-testid={`cart-decrease-${i.id}`} className="h-7 w-7 rounded-full border border-[#E8E3DA] flex items-center justify-center hover:border-[#B83A14] transition-colors">
                        <Minus className="h-3 w-3" />
                      </button>
                      <span className="w-6 text-center text-sm" data-testid={`cart-qty-${i.id}`}>{i.quantity}</span>
                      <button onClick={() => updateQty(i.id, 1)} data-testid={`cart-increase-${i.id}`} className="h-7 w-7 rounded-full border border-[#E8E3DA] flex items-center justify-center hover:border-[#B83A14] transition-colors">
                        <Plus className="h-3 w-3" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-[#E8E3DA] px-6 py-5 space-y-4">
              <div className="flex justify-between items-baseline">
                <span className="text-[#3D352F]">Subtotal</span>
                <span className="font-serif text-2xl text-[#1E1A17]" data-testid="cart-total">₹{total}</span>
              </div>
              <p className="text-xs text-[#B4A79A]">Delivery charges confirmed on WhatsApp based on your Delhi NCR location.</p>
              <Button
                data-testid="checkout-button"
                onClick={() => { setDrawerOpen(false); setCheckoutOpen(true); }}
                className="w-full rounded-full bg-[#B83A14] hover:bg-[#942B0D] text-white h-12 text-sm tracking-wide"
              >
                Proceed to order
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
